import React from 'react';
import { wrapFormComponentWithLabelAndError } from './StyledFormComponentWrappers';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

// SingleCheckboxField is wrapped with StyledLabelAndError, so the label
// is on the left and the checkbox lines up with other fiels in the form.

// SimpleCheckboxField is not wrapped with StyledLabelAndError, and inserts its
// own label to the right of the checkbox.

const RawSingleCheckboxInput = props => {
  const { name, ...otherInputProps } = props;
  return (
    <input
      name={name}
      id={name}
      type="checkbox"
      className="checkbox"
      checked={props.value}
      {...otherInputProps}
    />
  );
};

RawSingleCheckboxInput.displayName = 'RawSingleCheckboxInput';

export { RawSingleCheckboxInput };

const RawSingleCheckboxField = wrapFormComponentWithLabelAndError(RawSingleCheckboxInput);
RawSingleCheckboxField.displayName = 'RawSingleCheckboxField';

export { RawSingleCheckboxField };

const SingleCheckboxField = connectFormComponentToReduxForm(RawSingleCheckboxField, {
  normalize: value => !!value,
});
SingleCheckboxField.displayName = 'SingleCheckboxField';

export default SingleCheckboxField;
